import React, { Fragment, useEffect } from "react";
import Cards from "../Card/Cards";
import CoInfo from "../Sections/CoInfo";
import Intoduction from "../Sections/Intoduction";
import News from "../Sections/News";
import OverView from "../Sections/Overview";
import PopularSite from "../Sections/PopularSites";
import SampleRef from "../Sections/SampleRef";
import SpecialEvent from "../Sections/SpecialEvent";
import Products from "./Products";
import Blogs from "../Sections/Blogs";
const MainPage = () => {
  useEffect(() => {
    require("../../utils/script");
  }, []);
  return (
    <Fragment>
      {/* <SpecialEvent imgUrl="images/banner1.jpg" /> */}
      <Intoduction />
      <Cards />
      {/* <CoInfo /> */}
      <OverView />
      <PopularSite />
      <SampleRef />
      <Blogs />
      <News />
    </Fragment>
  );
};

export default MainPage;
